import { TFunction } from 'i18next';

import {
  AGE_VALIDATION,
  HEIGHT_VALIDATION,
  WEIGHT_VALIDATION,
} from '@src/constants';
import { kgToLbs } from '@src/helpers/forms.helpers';
import { cmToFeetInches } from '@src/helpers/height.helpers';

export const getFieldsErrorMessages = (t: TFunction) => ({
  NOT_VALID: t('default:fieldsErrorMassage.notValid'),
  REQUIRED: t('default:fieldsErrorMassage.required'),
  NOT_MATCH: t('default:fieldsErrorMassage.currentPasswordsDoNotMatch'),
  QUIZ_HEIGHT_METRIC: t('fieldsErrorMassage.heightInCentimeters', {
    min: HEIGHT_VALIDATION.minMax[0],
    max: HEIGHT_VALIDATION.minMax[1],
  }),
  QUIZ_HEIGHT_IMPERIAL: t('fieldsErrorMassage.heightInInches', {
    min: cmToFeetInches(HEIGHT_VALIDATION.minMax[0]).formatted,
    max: cmToFeetInches(HEIGHT_VALIDATION.minMax[1]).formatted,
  }),
  QUIZ_WEIGHT_METRIC: t('fieldsErrorMassage.validWeightKG', {
    min: WEIGHT_VALIDATION.minMax[0],
    max: WEIGHT_VALIDATION.minMax[1],
  }),
  QUIZ_WEIGHT_IMPERIAL: t('fieldsErrorMassage.validWeightPounds', {
    min: kgToLbs(WEIGHT_VALIDATION.minMax[0]),
    max: kgToLbs(WEIGHT_VALIDATION.minMax[1]),
  }),
  QUIZ_AGE_MIN: t('fieldsErrorMassage.minAge', {
    min: AGE_VALIDATION.minMax[0],
  }),
  QUIZ_AGE_MAX: t('fieldsErrorMassage.maxAge', {
    max: AGE_VALIDATION.minMax[1],
  }),
  QUIZ_NAME_LETTERS_ONLY: t('socials.name.error.noLetters'),
});
